import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Banner from '../../atoms/Banner/Banner';
import Image from '../../atoms/Image/Image';
import ContentBox from '../../molecules/ContentBox';

const bd = {
  imgSrc: '/images/image/message title@2x.png',
  imgSrcM: '/images/image/messagem title@2x.png',
  title: 'BI Introduce',
  text1: 'Introducing Korea’s best security leader training institute, the Korea',
  text2: 'Information Technology Research Institute.',
};

const biImages = ['/images/BI1@2x.png', '/images/BI2@2x.png', '/images/BI3@2x.png'];

const biText = `The symbol of the Next Generation Security Leader
Training Program (Best of the Best) is
In the shape of a shield with strong defense,
is a symbol of the goal of nurturing the best leaders in
information security through the BoB.`;

const downloadData = process.env.PUBLIC_URL + '/download/bob_bi.zip';

const colorData = [
  {
    name: 'BOB SKY BLUE',
    color: '#0062ac',
    text: 'C100 M20 Y0 K10',
  },
  {
    name: 'BOB BLUE',
    color: '#0b508a',
    text: 'C99 M75 Y19 K4',
  },
];

export default function BIIntroducePage() {
  const classes = useStyles();

  const downloadFile = () => {
    const a = document.createElement('a');
    a.href = downloadData;
    a.download = `bob_bi.zip`;
    a.click();
    a.remove();
  };

  return (
    <Box className={classes.root}>
      <Banner bannerData={bd} />

      <ContentBox outerData={<Box className={classes.outerBox} />}>
        <Box className={classes.main}>
          <Box className={classes.leftBox}>
            {biImages.map((b, i) => {
              return <Image key={i} className={classes.img} src={b} alt={`BI Introduce Image${i + 1}`} />;
            })}
          </Box>
          <Box className={classes.rightBox}>
            <pre className={classes.rightText}>{biText}</pre>
            <button onClick={downloadFile} className={classes.download}>
              BI(.ai) download
            </button>
            <Box className={classes.rightBottom}>
              {colorData.map((c, i) => {
                return (
                  <Box className={classes.colors} key={i}>
                    <Box className={classes.colorBox} style={{ backgroundColor: c.color }}>
                      {c.name}
                    </Box>
                    <Box className={classes.colorText}>{c.text}</Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>
      </ContentBox>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {},
  inner: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid black',
    alignItems: 'center',
    boxSizing: 'border-box',
    '@media only screen and (max-width: 1280px)': {
      paddingLeft: '32px',
    },
  },
  outerBox: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: '#f4f6f9',
    width: '1340px',
    height: '840px',
    zIndex: -1,
    '@media only screen and (max-width: 1920px)': {
      width: '1072px',
    },
    '@media only screen and (max-width: 1280px)': {
      width: '720px',
    },
    '@media only screen and (max-width: 768px)': {
      width: '384px',
    },
    '@media only screen and (max-width: 425px)': {
      width: '212.5px',
    },
  },
  content: {
    width: '100%',
    maxWidth: '1280px',
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media only screen and (max-width: 1023px)': {
      flexDirection: 'column',
    },
  },
  leftBox: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '214px',
    marginRight: '24px',
    '@media only screen and (max-width: 1023px)': {
      paddingTop: '0px',
      alignItems: 'center',
      marginRight: '0px',
    },
  },
  img: {
    marginBottom: '20px',
    width: '100%',
    maxWidth: '464px',
  },
  rightBox: {
    paddingTop: '255px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    '@media only screen and (max-width: 1023px)': {
      paddingTop: '64px',
    },
  },
  rightText: {
    whiteSpace: 'pre-wrap',
    textAlign: 'right',
    fontSize: '24px',
    '@media only screen and (max-width:768px)': {
      fontSize: '16px',
    },
  },
  download: {
    backgroundColor: '#191919',
    color: '#f4f4f4',
    width: '188px',
    height: '40px',
    border: '0',
    cursor: 'pointer',
    fontSize: '16px',
    paddingLeft: '20px',
    textAlign: 'left',
    '&:active': {
      backgroundColor: '#19191960',
    },
  },
  rightBottom: {
    display: 'flex',
    marginTop: '290px',
    paddingBottom: '384px',
    width: '100%',
    '@media only screen and (max-width: 1023px)': {
      marginTop: '48px',
      width: '576px',
    },
    '@media only screen and (max-width: 640px)': {
      flexDirection: 'column',
      width: '100%',
    },
  },
  colors: {
    maxWidth: '616px',
    width: '100%',
  },
  colorBox: {
    width: '100%',
    maxWidth: '308px',
    height: '68px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    color: theme.color.white,
    padding: '11px 10px ',
    boxSizing: 'border-box',
    fontSize: '18px',
    '@media only screen and (max-width:768px)': {
      fontSize: '16px',
    },
    '@media only screen and (max-width: 640px)': {
      maxWidth: 'none',
    },
  },
  colorText: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '11px 10px',
    boxSizing: 'border-box',
    fontSize: '18px',
    '@media only screen and (max-width:768px)': {
      fontSize: '16px',
    },
  },
}));
